module.exports = __webpack_public_path__ + "img/email.7031eedc.svg";